import DecisionModal from "./DecisionModal"
import MapIconLabelModal from "./MapIconLabelModal"
import { ModalNames } from "./types"
import OrganizationEditorModal from "./OrganizationEditorModal"
import InviteEverywhereModal from "./Invite/InviteEverywhereModalContainer"
import { WorkspaceConfirmationModalRegistry } from "./WorkspaceConfirmationModalRegistry"
import { WorkspaceAccessModal } from "./WorkspaceCollaborators/WorkspaceAccessModal"
import { ExportLayersModal } from "./ExportLayers/ExportLayersModal"
import { RequestAccessModal } from "./Invite/RequestAccessModal"
import { AssignSubscriptionsModal } from "features/data-management/workspace/subscriptions/modals/AssignSubscriptionsModal"
import { LicenseCheckoutModal } from "features/data-management/workspace/subscriptions/modals/LicenseCheckoutModal"
import { ActivateKeyModal } from "features/data-management/workspace/subscriptions/modals/ActivateKeyModal"
import { AddOnPaywallModal } from "features/data-management/workspace/subscriptions/modals/AddOnPaywallModal"
import { LicensePaywallModal } from "features/data-management/workspace/subscriptions/modals/LicensePaywallModal"
import { LicenseUpgradeModal } from "features/data-management/workspace/subscriptions/modals/LicenseUpgradeModal"
import { PaymentSuccessModal } from "features/data-management/workspace/subscriptions/modals/PaymentSuccessModal"
import { LiveVideoTutorialModal } from "plugins/Video/LiveVideo/modals/LiveVideoDataModal"
import { WelcomeToNovaModal } from "./WelcomeToNovaModal"
import { TAKAuthModal } from "features/data-management/workspace/workspace/body/settings-and-collaborators/integrations/tak/TAKAuthModal"
import { CalTopoAuthModal } from "features/data-management/workspace/workspace/body/settings-and-collaborators/integrations/caltopo/CalTopoAuthModal"
import { TryOurAddOnsModal } from "panels/content/side-panel/modals/try-add-ons/TryOurAddOnsModal"
import { TryHotspotsModal } from "panels/content/side-panel/modals/try-add-ons/TryHotspotsModal"
import { FunctionComponent, type JSX } from "react"
import { TryColorfinderModal } from "panels/content/side-panel/modals/try-add-ons/TryColorfinderModal"
import { TryLiveVideoModal } from "panels/content/side-panel/modals/try-add-ons/TryLiveVideoModal"
import { TryPanoramaModal } from "panels/content/side-panel/modals/try-add-ons/TryPanoramaModal"
import { TryOrthomosaicsModal } from "panels/content/side-panel/modals/try-add-ons/orthomosaics/TryOrthomosaicsModal"
import { WelcomeTryOrthomosaicsModal } from "panels/content/side-panel/modals/try-add-ons/orthomosaics/WelcomeTryOrthomosaicsModal"
import { TryVideoModal } from "panels/content/side-panel/modals/try-add-ons/TryVideoModal"
import { ScreenSizeAlertModal } from "./ScreenSizeAlertModal"
import { BrowserAlertModal } from "./BrowserAlertModal"
import { UnarchiveLayersModal } from "panels/content/side-panel/modals/UnarchiveLayersModal"
import { ChooseLiveVideoTypeModal } from "panels/content/side-panel/modals/live-video/ChooseLiveVideoTypeModal"
import { LiveVideoMobileModal } from "panels/content/side-panel/modals/live-video/LiveVideoMobileModal"
import { DjiEnterpriseOcaModal } from "panels/content/side-panel/modals/live-video/DjiEnterpriseOcaModal"
import { UserProfileModalContainer } from "features/users/UserProfileModal"
import { SkydioLiveStreamModal } from "panels/content/side-panel/modals/live-video/SkydioLiveStreamModal"
import { FlirMmaLiveStreamModal } from "panels/content/side-panel/modals/live-video/SpurAviation"
import { FeatureFlagToggleModal } from "features/feature-flags/FeatureFlagToggleModal"

// to avoid injecting functional components into the redux state,
// we must have a way to reference components via name. this map achieves
// it. To keep things less confusing, we should only define bare-bone modals in a wrapper-component format
// in this folder. The actual content of the modal can then live with the associated feature.
export const ModalMap: Record<
    ModalNames,
    { component: (() => JSX.Element | null) | FunctionComponent; mappedName: ModalNames }
> = {
    OrganizationEditorModal: {
        component: OrganizationEditorModal,
        mappedName: ModalNames.OrganizationEditorModal,
    },
    DecisionModal: {
        component: DecisionModal,
        mappedName: ModalNames.DecisionModal,
    },
    MapIconLabelModal: {
        component: MapIconLabelModal,
        mappedName: ModalNames.MapIconLabelModal,
    },
    InviteEverywhereModal: {
        component: InviteEverywhereModal,
        mappedName: ModalNames.InviteEverywhereModal,
    },
    WorkspaceConfirmationModal: {
        component: WorkspaceConfirmationModalRegistry,
        mappedName: ModalNames.WorkspaceConfirmationModal,
    },
    WorkspaceAccessModal: {
        component: WorkspaceAccessModal,
        mappedName: ModalNames.WorkspaceAccessModal,
    },
    RequestAccessModal: {
        component: RequestAccessModal,
        mappedName: ModalNames.RequestAccessModal,
    },
    ExportLayersModal: {
        component: ExportLayersModal,
        mappedName: ModalNames.ExportLayersModal,
    },
    AssignSubscriptionsModal: {
        component: AssignSubscriptionsModal,
        mappedName: ModalNames.AssignSubscriptionsModal,
    },
    LicenseCheckoutModal: {
        component: LicenseCheckoutModal,
        mappedName: ModalNames.LicenseCheckoutModal,
    },
    ActivateKeyModal: {
        component: ActivateKeyModal,
        mappedName: ModalNames.ActivateKeyModal,
    },
    AddOnPaywallModal: {
        component: AddOnPaywallModal,
        mappedName: ModalNames.AddOnPaywallModal,
    },
    LicensePaywallModal: {
        component: LicensePaywallModal,
        mappedName: ModalNames.LicensePaywallModal,
    },
    LicenseUpgradeModal: {
        component: LicenseUpgradeModal,
        mappedName: ModalNames.LicenseUpgradeModal,
    },
    PaymentSuccessModal: {
        component: PaymentSuccessModal,
        mappedName: ModalNames.PaymentSuccessModal,
    },
    LiveVideoTutorialModal: {
        component: LiveVideoTutorialModal,
        mappedName: ModalNames.LiveVideoTutorialModal,
    },
    UnarchiveLayers: {
        component: UnarchiveLayersModal,
        mappedName: ModalNames.UnarchiveLayers,
    },
    WelcomeToNovaModal: {
        component: WelcomeToNovaModal,
        mappedName: ModalNames.WelcomeToNovaModal,
    },
    TAKAuthModal: {
        component: TAKAuthModal,
        mappedName: ModalNames.TAKAuthModal,
    },
    CalTopoAuthModal: {
        component: CalTopoAuthModal,
        mappedName: ModalNames.CalTopoAuthModal,
    },
    WelcomeTryOrthomosaicsModal: {
        component: WelcomeTryOrthomosaicsModal,
        mappedName: ModalNames.WelcomeTryOrthomosaicsModal,
    },
    TryOurAddOnsModal: {
        component: TryOurAddOnsModal,
        mappedName: ModalNames.TryOurAddOnsModal,
    },
    TryOrthomosaicsModal: {
        component: TryOrthomosaicsModal,
        mappedName: ModalNames.TryOrthomosaicsModal,
    },
    TryHotspotsModal: {
        component: TryHotspotsModal,
        mappedName: ModalNames.TryHotspotsModal,
    },
    TryColorfinderModal: {
        component: TryColorfinderModal,
        mappedName: ModalNames.TryColorfinderModal,
    },
    TryLiveVideoModal: {
        component: TryLiveVideoModal,
        mappedName: ModalNames.TryLiveVideoModal,
    },
    TryVideoModal: {
        component: TryVideoModal,
        mappedName: ModalNames.TryVideoModal,
    },
    TryPanoramaModal: {
        component: TryPanoramaModal,
        mappedName: ModalNames.TryPanoramaModal,
    },
    ScreenSizeAlertModal: {
        component: ScreenSizeAlertModal,
        mappedName: ModalNames.ScreenSizeAlertModal,
    },
    BrowserAlertModal: {
        component: BrowserAlertModal,
        mappedName: ModalNames.BrowserAlertModal,
    },
    ChooseLiveVideoTypeModal: {
        component: ChooseLiveVideoTypeModal,
        mappedName: ModalNames.ChooseLiveVideoTypeModal,
    },
    LiveVideoMobileModal: {
        component: LiveVideoMobileModal,
        mappedName: ModalNames.LiveVideoMobileModal,
    },
    DjiEnterpriseOcaModal: {
        component: DjiEnterpriseOcaModal,
        mappedName: ModalNames.DjiEnterpriseOcaModal,
    },
    UserProfileModal: {
        component: UserProfileModalContainer,
        mappedName: ModalNames.UserProfileModal,
    },
    SkydioLiveStreamModal: {
        component: SkydioLiveStreamModal,
        mappedName: ModalNames.SkydioLiveStreamModal,
    },
    FlirMmaLiveStreamModal: {
        component: FlirMmaLiveStreamModal,
        mappedName: ModalNames.FlirMmaLiveStreamModal,
    },
    FeatureFlagToggleModal: {
        component: FeatureFlagToggleModal,
        mappedName: ModalNames.FeatureFlagToggleModal,
    },
}

export default ModalMap
